// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| AUTHENTICATION 1 WRAPPER ||============================== //

const AuthWrapper1 = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' 
        ? theme.palette.background.default 
        : theme.palette.grey[50],
    minHeight: '100vh',
    width: '100%',
    maxWidth: '100%',
    position: 'relative',
    overflow: 'hidden',
    margin: 0,
    padding: 0
}));

export default AuthWrapper1;
